import React, { useState } from "react";
import TabbedViewWithDateSelect from "../../components/TabbedViewWithDateSelect/TabbedViewWithDateSelect";
import { JLR_PLANT } from "../../constants";
import { usePlantAndLinesStore } from "../../providers/PlantAndLinesStore/PlantAndLinesStore";
import LineCapacity from "../../components/LineCapacity/LineCapacity";

const LineCapacityConfigurator = () => {
  const [plant] = usePlantAndLinesStore().plantState;

  const [lineCapacityCount, setLineCapacityCount] = useState(0);

  const title = "Line Capacity Configurator";

  return (
    <div>
      <TabbedViewWithDateSelect
        tabs={[
          {
            label: "Line Capacity",
            title,
            count: lineCapacityCount,
            countColor: plant.label === JLR_PLANT ? "green" : "blue",
            backgroundColor: plant.label === JLR_PLANT ? "green" : "blue",
            component: LineCapacity,
            props: {
              handleCountChange: setLineCapacityCount,
            },
          },
        ]}
        pageTitle={title}
      />
    </div>
  );
};

export default LineCapacityConfigurator;
